import React, {Component} from 'react';
import ClientSideCacheController from '../ClientSideCacheController'
import Cannonicalize from '../Cannonicalize'
import Analytics from '../Analytics'
const daysOfWeek = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August','September', 'October', 'November', 'December']
class BaronNineDayForecast extends Component{
  constructor(props){
    super(props)
    this.affiliate = this.props.affiliate;
    this.state = {
      forecasts: [],
      sunNineDay: [],
      detailIndex: -1
    }

    this.maxTemp = 0;
  }



  componentWillMount(){
    try {
      this.setState({forecasts: Cannonicalize.nineDayForecast(this.props.FRN_rawResponses[0].data)})
    } catch (e) {
      e.message += ' in BaronNineDayForecast'
      Analytics.reportError(e)
    }

    try {
      this.setState({sunNineDay: Cannonicalize.sunNineDay(this.props.FRN_rawResponses[1].data)})
    } catch (e) {
      e.message += ' in BaronNineDayForecast'
      Analytics.reportError(e)
    }

    if(typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('nineDayForecast').then((data)=>{
      data.detailIndex = -1 ;
      // console.log('nineDayForecast', data);
      this.setState({forecasts: data})
    })

    ClientSideCacheController.get('sunNineDay').then((data)=>{
      // console.log('sunNineDay', data);
      this.setState({sunNineDay: data})
    })
  }

  componentDidMount(){
    document.onkeydown = (e)=>{
      if(e.keyCode === 27)
        this.setState({detailIndex: -1})
    }
  }


  render(){
    // return <span>{JSON.stringify(this.state.forecasts)}</span>
    if(!this.state.forecasts.length  )
      return null
    return(
      <div className="gnm-baron-nine-day-forecast"  >
        <div className='scrollable-inner'>
          <div style={{width:'900px'}} className="hidden-md hidden-lg"> {/* 100 is built in to CSS*/}
          {this.state.forecasts.map((f,i,all)=>{
            return  (
              <div key={i}>
                <BaronDay {...f} affiliate={this.affiliate} onClick={()=>{
                    this.setState({detailIndex: i})
                  }} />
                <BaronDetail {...f} detailIndex={this.state.detailIndex} key={'b' + i} index={i} sunTimes={this.state.sunNineDay[i] || {}} onClick={()=>{
                    this.setState({detailIndex: -1})
                  }} />
              </div>
            )
          })}
          </div>
          <div className="visible-md-block visible-lg-block"> {/* 100 is built in to CSS*/}
          {this.state.forecasts.map((f,i,all)=>{
            return  (
              <div key={i}>
                <BaronDay {...f} affiliate={this.affiliate} onClick={()=>{
                    this.setState({detailIndex: i})
                  }} />
                <BaronDetail {...f} detailIndex={this.state.detailIndex} key={'b' + i} index={i} sunTimes={this.state.sunNineDay[i] || {}} onClick={()=>{
                    this.setState({detailIndex: -1})
                  }} />
              </div>
            )

          })}
          </div>
        </div>
      </div>
    )

  }
}

const BaronDetail = props => {
    let sunTimes = props.sunTimes || {}
    if(!props.daytime )
      return null
    try{
      let title = ''
      if(props.daytime && props.daytime.valid_begin){
        let today = new Date(props.daytime.valid_begin)
        title = `Outlook for ${daysOfWeek[today.getDay()]}, ${months[today.getMonth()]} ${today.getDate()} ${today.getFullYear()}`
      }



      return(
        <div className="full-info" style={{display: props.detailIndex === props.index? 'block': 'none'}} onClick={props.onClick} >
          <div className='clickable-clear-background'></div>
          <div className="full-title">{title} <span className="fa fa-close"></span></div>
          <div className="full-contents" >
            <div className="condition">{props.daytime.weather_code.text }</div>
            <img className=" fixed-width" src={props.daytime.conditionIcon}></img>
            <span className='high'>{props.temperature.max}&deg;</span>
              {
                (props.daytime.precipitation.probability && props.daytime.precipitation.value)
                ? <ul>
                    <li>Chance of Rain</li>
                    <li ><h4>{props.daytime.precipitation.probability.value + '%'  }</h4></li>
                  </ul>
                : null
              }
              {
                (props.daytime.wind && props.daytime.wind.speed)
                ? <ul>
                    <li>Wind</li>
                    <li >{props.daytime.wind.dir + ' ' + Math.round(props.daytime.wind.speed) + ' MPH'}</li>
                  </ul>
                : null
              }
            <ul>
              <li>Sunrise</li>
              <li><p>{sunTimes.sunRise}</p></li>
            </ul>
            <ul>
              <li>Sunset</li>
              <li><p>{sunTimes.sunSet}</p></li>
            </ul>
            <p>{props.daytime.text}</p>
          </div>
        </div>
      )
    } catch(e){
      console.log('Detail in Baron Nine Day Forecast render error',e);
      return null
    }


}

const BaronDay = props => {
  if(!props.daytime)
    return null
  try{
    let dayOfWeek = new Date(props.daytime.valid_begin).getDay()
    dayOfWeek = daysOfWeek[dayOfWeek]
    return (
              <div className="day" onClick={props.onClick}>
                <div className= "summary" >
                  <div className="title ">
                    <h2 className={dayOfWeek}>{dayOfWeek.substring(0,3)}</h2>
                  </div>
                  <div className="hidden-xs hidden-sm condition-description">{props.daytime.weather_code.text}</div>
                  <div className="img">
                    <img src={props.daytime.conditionIcon} className="img-responsive"></img>
                  </div>
                  <h3>{props.temperature.max}&deg;</h3>
                  <h4>{props.temperature.min}&deg;</h4>
                  <h5 >
                    {(props.daytime.precipitation.probability && props.daytime.precipitation.value )? <span className="fa fa-umbrella"/> : null}
                    {props.daytime.precipitation.probability ? props.daytime.precipitation.probability.value + '%' : null }
                  </h5>
                  <div className="details">View Details</div>
                </div>
              </div>
          )
  } catch(e){
    console.log('Day in Baron Nine Day Forecast render error',e);
    return null
  }
}


export default BaronNineDayForecast



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronNineDayForecast/index.js